<template>
    <div class="rv-city mt-4 position-relative" v-click-outside="outside">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <input :class="citySelect.name != '' ? 'border-primary' : ''" type="text" id="inputCity"
                v-model="citySelect.name" @focus="focusInput"
                @input="search()"/>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': citySelect.name != ''
                }">Tỉnh thành</label>
        </div>
        <div class="position-absolute w-100 pt-1 z-index-list" v-show="activeCity">
            <div :class="{
                        'list-city bg-white': true,
                        'vg-scrollbar': showCity.length > 0,
                        'py-4 text-center': showCity.length == 0 && citySelect.name !== ''
                    }">
                <div v-for="(item, index) in showCity" :key="index" class="item-list" @click="choseCity(item)">
                    {{ item.name }}
                </div>
                <p class="mb-0" v-show="showCity.length == 0 && citySelect.name !== ''">Không có kết quả phù hợp</p>
            </div>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>

<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            activeCity: false,
            city: [],
            showCity: [],
            citySelect: {
                name: '',
                id: '',
            }
        }
    },
    watch: {
        data(val){
            this.citySelect.id = val;
            this.filterName();
        },
    },
    async created() {
        this.citySelect.id = this.data;
        this.filterName();
        await this.getCity();
    },
    methods: {
        focusInput(e) {
            this.activeCity = true;
            if(this.citySelect.id !== ''){
                e.target.select();
            }
        },
        emitData(){
            this.$emit('update:data', this.citySelect.id);
        },
        filterName(){
            this.city.map(item => {
                if(item.id == this.citySelect.id) this.citySelect.name = item.name;
            });
        },
        search(){
            this.citySelect.id = '';
            this.emitData();
            this.showCity = [];
            this.city.map(item => {
                if(item.name.toLowerCase().includes(this.citySelect.name.toLowerCase()) == true){
                    this.showCity.push(item);
                }
            });
        },
        async getCity() {
            this.vloading = true;
            await apiGet('/v2/country').then(res => {
                let data = [];
                for (const key in res) {
                    if (key != '_debugbar') {
                        data.push(res[key]);
                    }
                }
                this.city = data;
                this.showCity = data;
            });
            this.vloading = false;
            this.filterName();
        },
        choseCity(country) {
            this.citySelect = {
                id: country.id,
                name: country.name
            }
            this.emitData();
            this.$emit('update:error', '');
            this.activeCity = false;
        },
        outside(e){
            this.activeCity = false;
        }
    }
}
</script>

<style lang="scss">
.rv-create {
    .body {
        .rv-city {
            .dropdown-city {
                background: #fff;
                border-radius: 4px;
                border: 1px solid #007bff;
            }
            .text-name-city {
                top: -13px;
                padding: 0 10px;
                background: #fff;
                margin-left: 10px;
            }
            .list-city {
                border: 1px solid rgba(0, 0, 0, 0.2);
                border-radius: 4px;
                box-shadow: 0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08);
                max-height: 400px;
                overflow-y: auto;
                .item-list {
                    padding: 10px;
                    &:hover {
                        background: #ddd;
                    }
                }
            }
            .z-index-list {
                z-index: 1000;
            }
            .line-loading {
                width: 100%;
                height: 3px;
                position: relative;
                &:before {
                    content: "";
                    position: absolute;
                    right: auto;
                    left: 0;
                    height: 100%;
                    background-color: #0c81f6;
                    animation: lineLoading 1s forwards infinite linear;
                }
            }
            @keyframes lineLoading {
                0% {
                    right: 100%;
                }

                50% {
                    right: 0;
                    left: 0;
                }

                100% {
                    right: 0;
                    left: 100%;
                }
            }
        }
    }
}
</style>
